import * as React from "react";
const SvgDocumentPile = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2h8l4 4v12H8zm2.002 2L10 16h8V7h-3V4z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "currentColor", d: "M4 7h2v13h10v2H4z" })));
export default SvgDocumentPile;
//# sourceMappingURL=DocumentPile.js.map